import { Badge } from "@/components/ui/badge"

const TONE: Record<string, "accent" | "signal" | "muted" | "solid" | "neutral"> = {
  active: "accent",
  canceling: "signal",
  past_due: "signal",
  incomplete: "muted",
  lapsed: "muted",
  canceled: "solid",
  none: "neutral",
}

export function AccountLifecycleBadge({ status }: { status: string }) {
  return <Badge tone={TONE[status] ?? "neutral"}>{status.replace("_", " ")}</Badge>
}
